import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Buttons } from '@taxdown/piccolo-web';
import { hideModalAction } from 'Store/modules/app/actions';
import { modalSelector } from 'Store/modules/app/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import PdfIframe from 'Components/PdfIframe';
import { CloseIcon } from 'Components/icons';
import { stages } from 'Constants/stages';
import { removeOverflow, setBodyOverflow } from 'Styles/utils/utils';
import * as Styled from './styles';

const PdfModal = (): JSX.Element => {
  const modal = useSelector(modalSelector);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { options } = modal;
  const { userStage, pdf, cepFile } = options;
  const isValidationStage = userStage === stages.FILED;

  useEffect(() => {
    setBodyOverflow();
  }, []);
  const closeModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
  };

  return (
    <Styled.ModalContainer>
      <Styled.CloseButton onClick={closeModal}>
        <CloseIcon />
      </Styled.CloseButton>
      <Styled.ModalContent isValidationStage={isValidationStage}>
        <PdfIframe pdfUrl={pdf} cepFile={cepFile} />
        {isValidationStage && (
          <Styled.ButtonActions justify="center">
            <Buttons.Classic mode="secondary" label={t('Button.contact')} size="m" />
            <Buttons.Classic mode="primary" label={t('PDFModal.validate.CTA')} size="m" />
          </Styled.ButtonActions>
        )}
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default PdfModal;
